import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MaintenanceInfo } from '../types/maintenance';

const initialState: MaintenanceInfo = {
  isMaintenance: false,
  maintenance: null,
  showNotice: false,
  notice: null,
};
const MaintenanceSlice = createSlice({
  name: 'maintenance',
  initialState,
  reducers: {
    setMaintenanceInfo(_state, action: PayloadAction<MaintenanceInfo>) {
      return action.payload;
    },
  },
});

export default MaintenanceSlice;
export const { setMaintenanceInfo } = MaintenanceSlice.actions;
